/* eslint-disable camelcase */
import { anyUserCan } from 'src/types';
import constructLocalEntity from 'src/utils/vuexModuleConstructor/constructLocalEntity';
import localEntityListInMenuItem from 'src/utils/mainMenuOperations/localEntityListInMenuItem';
import { id, name, row_menu } from 'src/utils/entityOperations/columns/basicColumns';
import { isToggle } from 'src/types/columnFlags';
const controlledActions = anyUserCan();
const columns = () => {
    return [
        row_menu({ menuItemShortcuts: ['del', 'copy'] }),
        id(),
        name(),
        { name: 'parent_id' },
        { name: 'disabled', isToggle },
        { name: 'is_app_node', isToggle },
    ];
};
const remoteEntityName = 'preferences.option_groups';
const localEntityName = remoteEntityName;
const localEntity = constructLocalEntity({
    columns,
    entityLabel: 'Preference Option Group',
    entityLabelPlural: 'Preference Option Groups',
    remoteEntityName,
    apiVersion: 1,
    controlledActions,
    pageTitle: 'Preference Option Groups',
});
export default localEntity;
export const optionGroups__menuItem = (params) => (Object.assign(Object.assign({ label: 'Preference Option Groups', icon: { name: 'mdi-keyboard-outline' }, prefetch: true }, localEntityListInMenuItem({
    localEntityNameProp: localEntityName,
    tableIdProp: localEntityName
})), params));
